// @flow
import React from 'react';
import Experiment from '@homeaway/react-experiment';
import {FormattedMessage} from 'react-intl';
import NoResultsBanner from '../NoResultsBanner/NoResultsBanner';
import {HA_SERP_ZERO_RESULTS_BANNER} from '../../abacus/experiments';

export const NoResultsMsg = () => (
    <div className="NoResults">
        <FormattedMessage
            id="noresults"
            defaultMessage="There are no results which match your criteria. Try refining your search parameters."
        />
    </div>
);

type Props = {numFilters?: number};

const NoResults = ({numFilters = 0}: Props) => {
    if (numFilters > 0) {
        return (
            <Experiment name={HA_SERP_ZERO_RESULTS_BANNER}>
                {({On, Off}) => (
                    <React.Fragment>
                        <On>
                            <NoResultsBanner />
                        </On>
                        <Off>
                            <NoResultsMsg />
                        </Off>
                    </React.Fragment>
                )}
            </Experiment>
        );
    }
    return <NoResultsMsg />;
};
NoResults.displayName = 'NoResults';

export default NoResults;
